import { getUrlParam } from '@shared/utils/base'
import { ConfigService, product_id_info } from '@/services/config.service';

/** 是否使用测试环境接口。 */
const isTest = process.env.STAGE === 'test' || process.env.NODE_ENV === 'development'

/** win看图大师 6291 渠道：以 6290 为蓝本，使用独立产品 ID 154。 */
export class AiImageEditor6291Service extends ConfigService {
  /** 获取区分场景套餐id */
  get scenePackageId () {
    /** 当前页面场景，用于选择套餐。 */
    const sceneName = getUrlParam('scene')
    /** 场景对应的套餐后缀；未匹配时沿用首页套餐。 */
    const scene_info = {
      home: '001',
      wxmc: '010',
      koutu: '101'
    }

    return scene_info[sceneName] ?? '001'
  }

  /** 当前配置的渠道号。 */
  getTryno= '6291'
  /** 产品展示名称，沿用 6290 的 win看图大师。 */
  getTitle= 'win看图大师'
  /** 公众号登录应用标识。 */
  wxAppId= 'wx3a78d7213f1f9ee7'
  /** 微信网站应用扫码登录标识。 */
  wxWebAppId= 'wxfc38c276080e7d53'
  /** 产品 ID 与场景后缀组成的套餐 ID。 */
  getPackageId= product_id_info.aiImageEditor6291 + this.scenePackageId
  /** 当前场景套餐后缀。 */
  getScenePackageId= this.scenePackageId
  /** 产品图标资源。 */
  getLogo= require('@/assets/images/kantu/logo.png')
  /** 公众号登录引导图。 */
  getOfficialLoginImg= require('@/assets/images/kantu/guide_bg.png')
  /** 头部公众号二维码图片。 */
  getHeaderQrCodeImg= require('@/assets/images/kantu/qrcode_official.png')
  /** 产品官网地址。 */
  getWebsiteUrl= 'https://pic.keniu.com/'
  /** 会员权益描述。 */
  getMemberInterestDesc= '提供图片查看、图片编辑、图片美化、图片压缩、修改尺寸、高清放大、添加水印、图片转格式、批量重命名、高级打印、文字识别等权益'
  /** 会员协议地址。 */
  getMemberProtocolLink= 'https://privacy.kt.ydworkai.com/vipAgreement.html'
  /** 用户协议地址。 */
  getUserProtocolLink= 'https://privacy.kt.ydworkai.com/userAgreement.html'
  /** 隐私政策地址。 */
  getPrivacyPolicyLink= 'https://privacy.kt.ydworkai.com/privacyPolicy.html'
  /** 会员权益头图和内容图。 */
  getMemberInterestImgObj= {
    head: 'https://api-cos.keniu.com/interest/pic/pic_compare_header.png',
    content: 'https://api-cos.keniu.com/interest/pic/pic_compare.png',
  }

  // 产品账号注销须知
  getAccountDeleteProtocolLink= 'https://www.ijinshan.com/privacy/zhuxiaoxuzhi.html'

  /** 产品 154 的后端身份配置。 */
  getProductInfo= {
    appid: '154',
    secret: '47a60efcc16dec7040d13cc11199cc1a',
    version: 1
  }

  /** 普通会员与钻石会员类型标识。 */
  getMemberTypeInfo= {
    normal: 'fastpic_normal',
    diamond: 'fastpic_diamond'
  }

  /** 旧账号登录入口的图片、名称和产品 ID。 */
  getOldAccountLoginInfo = {
    img: require('@/assets/images/kantu/old_account_icon.png'),
    text: '极速看图',
    id: '17'
  }

  /** 账号注销提示，保留 6290 原有文案。 */
  getLogoffContent= `&nbsp;&nbsp;&nbsp;&nbsp;注销AI图片编辑账号为不可恢复的操作，建议您在最终确定注销前自行备份本账号相关的所有信息，并请再次确认与账号相关的所有服务均已妥善处理。<br />
    &nbsp;&nbsp;&nbsp;&nbsp;请谨记：注销AI图片编辑账号，您将无法再使用AI图片编辑账号或找回您添加的任何内容，包括但不限于：<br />
    1.确认注销后，账号将无法登录，如需使用服务，需注册新账号；<br />
    2.账号信息、身份信息、会员权益等将会被清空且无法找回；<br />
    3.如果您选择注销账号，则视为您自行放弃所购买的AI图片编辑会员服务，且我们无法协助您恢复。<br />`

  /** 账号注销成功提示。 */
  getLogoffSuccessContent= '该账号已注销，相关数据被删除'

  /** 按运行环境选择接口地址。 */
  getRequestUrl = isTest ? 'http://baoquvip.aix-test-k8s.iweikan.cn/' : 'https://api-picvip-kantu.knfastpic.com/'
}
